import { SpanControl } from "@/Common/Components/SpanControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { LabMessage } from "../Models/LabMessage";

interface LabReportReadingStatusComponentProps {
    LabMessage: LabMessage;
}

const statusMapper = {
    "ClassifiedByCollege": "ClassifiedByCollegeLabel",
    "SubmittedByCollege": "SubmittedByCollege",
    "Corrected": "CorrectedLabel",
    "Classified": "ClassifiedLabel",
    "Submitted": "OnHoldLabsInbox",
    "New": "NewLabel"
};

function LabReportReadingStatusComponent({ LabMessage }: Readonly<LabReportReadingStatusComponentProps>): JSX.Element {
    const statusValue = LabMessage.Model.ResolvedLabStatus;
    const { getText } = useTranslation();

    return (
        <SpanControl
            IsRed={LabMessage.IsAbnormal}
            IsBold={LabMessage.Model.IsUnreadForQueryingClinician}
            text={getText(statusMapper[statusValue])}
            className="LabReportReadingStatus"
        />
    );
}

export { LabReportReadingStatusComponent };
